import { ComponentProps, useEffect } from "react";
import * as S from "./styles";
import { useStepButtonScheduleDetail } from "./useStepButtonScheduleDetail";

interface IStepButtonScheduleDetailProps extends ComponentProps<"div"> {
  getFormNumber?: (n: number) => void;
}

export const StepButtonScheduleDetail = ({
  getFormNumber,
  ...rest
}: IStepButtonScheduleDetailProps) => {
  const { step, setStep } = useStepButtonScheduleDetail();

  useEffect(() => {
    getFormNumber && getFormNumber(step);
  }, [step]);

  return (
    <S.Container {...rest}>
      <S.Wrapper data-active={step === 1}>
        <S.ButtonStep
          onClick={() => {
            setStep(1);
          }}
        >
          Dados
        </S.ButtonStep>
      </S.Wrapper>

      <S.Wrapper data-active={step === 2}>
        <S.ButtonStep
          onClick={() => {
            setStep(2);
          }}
        >
          Faturas
        </S.ButtonStep>
      </S.Wrapper>

      <S.Wrapper data-active={step === 3}>
        <S.ButtonStep
          onClick={() => {
            setStep(3);
          }}
        >
          Histórico
        </S.ButtonStep>
      </S.Wrapper>

      <S.Wrapper data-active={step === 4}>
        <S.ButtonStep
          onClick={() => {
            setStep(4);
          }}
        >
          Incidentes
        </S.ButtonStep>
      </S.Wrapper>
    </S.Container>
  );
};
